export * from './tick-tock';
export * from './navbar';
export * from './footer';
export * from './about';
export * from './plans';
export * from './order';
export * from './cart';
export * from './no-content';
export * from './register';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/index.ts